import { Modal, Button, Input,Checkbox} from "antd";
import HTMLReactParser from "html-react-parser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './GenericModal.scss';

interface GenericModalProps {
  title: string;
  closable?: boolean;
  content: JSX.Element;
  okDanger?: boolean;
  onCancel: () => void;
  requiredTextConfirmation?: string;
  onOk?: () => void;
  visible: boolean;
  isLoading: boolean;
  requiredCheckboxText?: string;

}
export const GenericModal = (param: GenericModalProps) => {
  const { t } = useTranslation();

  const [textConfirmed, setTextConfirmed] = useState(
    param.requiredTextConfirmation ? false : true
  );

  const [checkboxConfirmed, setCheckboxConfirmed] = useState(
    param.requiredCheckboxText ? false : true
  );

  // 🔁 Reset al abrir/cerrar
  useEffect(() => {
    setTextConfirmed(param.requiredTextConfirmation ? false : true);
    setCheckboxConfirmed(param.requiredCheckboxText ? false : true);
  }, [
    param.visible,
    param.requiredTextConfirmation,
    param.requiredCheckboxText,
  ]);

  const acceptEnabled =
    textConfirmed &&
    checkboxConfirmed &&
    !param.isLoading;

  return (
    <Modal
      title={param.title}
      className="app-modal"
      open={param.visible}
      closable={param.closable}
      confirmLoading={param.isLoading}
      onCancel={param.onCancel}
      footer={[
        <Button
          key="cancel"
          className="app-white-button"
          onClick={param.onCancel}
        >
          {t("button.cancel")}
        </Button>,
        param.onOk && (
          <Button
            key="ok"
            type="primary"
            loading={param.isLoading}
            disabled={!acceptEnabled}
            className={`app-button ${param.okDanger ? "danger" : ""}`}
            onClick={param.onOk}
          >
            {t("button.accept")}
          </Button>
        ),
      ]}
    >
      {param.content}

      {/*  TEXT CONFIRMATION */}
      {param.requiredTextConfirmation && (
        <div className="required-text">
          {HTMLReactParser(
            t("actions.required-text-complete-confirmation", [
              param.requiredTextConfirmation,
            ])
          )}
          <Input
            placeholder={param.requiredTextConfirmation}
            onChange={(e) =>
              setTextConfirmed(
                e.target.value === param.requiredTextConfirmation
              )
            }
            className="app-input required-text-confirmation"
          />
        </div>
      )}

      {/*  CHECKBOX CONFIRMATION */}
      {param.requiredCheckboxText && (
        <div className="required-checkbox">
          <Checkbox
            checked={checkboxConfirmed}
            onChange={(e) => setCheckboxConfirmed(e.target.checked)}
          >
            {HTMLReactParser(param.requiredCheckboxText)}
          </Checkbox>
        </div>
      )}
    </Modal>
  );
};